interface SvgInterface {
    className?: string;
    style?: any;
}

export function DotIcon({className = '', style = {}}: SvgInterface) {
    return <svg className={className} style={style} id="icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs></defs><title/><circle cx="16" cy="16" r="8"/><rect className={`fill-none`} data-name="&lt;Transparent Rectangle&gt;" height="32" id="_Transparent_Rectangle_" width="32"/></svg>;
}